export default "__VITE_ASSET__Bp$p6a0C__"